import React, { useState } from 'react';
import { StyledRadio } from './styledComponents';
import useKey from '~utils/hooks/useKey';

type Props = {
  checked: boolean;
  color: string;
  children: React.ReactNode;
  name?: string;
  size?: number;
  className?: string;
  onChange?: (checked: boolean, name?: string) => void;
};

const Radio = ({
  size = 18,
  className,
  children,
  name,
  checked,
  color,
  onChange,
}: Props) => {
  const [isFocused, setIsFocused] = useState(false);

  const toggleIsFocused = () => setIsFocused((prev) => !prev);

  const handleChange = () => {
    if (onChange) {
      onChange(!checked, name);
    }
  };

  useKey(
    'keyup',
    'Enter',
    () => {
      if (isFocused) {
        handleChange();
      }
    },
    [isFocused],
  );

  return (
    <label>
      <StyledRadio
        tabIndex={0}
        color={color}
        size={size}
        className={className}
        onFocus={toggleIsFocused}
        onBlur={toggleIsFocused}
        isChecked={checked}
      />
      <input
        type='radio'
        name={name}
        checked={checked}
        onChange={() => handleChange()}
        hidden
      />
      {children}
    </label>
  );
};

export default Radio;
